import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from './cssModules/index.module.css';
import { ShirtTemplate } from "./upload/shirtTemplate.mjs";
import { HoodieTemplate } from "./upload/hoodie.mjs";
import { KurtaTemplate } from "./upload/kurta.mjs";
import { SareeTemplate } from "./upload/saree.mjs";
import { JacketTemplate } from "./upload/jacket.mjs";
import { Shawlemplate } from "./upload/shawl.mjs";
import { TracksuitTemplate } from "./upload/tracksuit.mjs";
import { LeggingsTemplate } from "./upload/leggings.mjs";
import { KurtiTemplate } from "./upload/kurti.mjs";
import { DressTemplate } from "./upload/dress.mjs";
import { TopTemplate } from "./upload/top.mjs";
import { CoordTemplate } from "./upload/coord.mjs";
import { SkirtTemplate } from "./upload/skirt.mjs";
import { LehengaTemplate } from "./upload/lehenga.mjs";
import { JeansTemplate } from "./upload/jeans.mjs";
import { EarringTemplate } from "./upload/earrings.mjs";
import { BandTemplate } from "./upload/sacredBand.mjs";
import { HandBagTemplate } from "./upload/handBag.mjs";
import { HandPurseTemplate } from "./upload/handPurse.mjs";
import { WalletTemplate } from "./upload/wallet.mjs";
import { BackpackTemplate } from "./upload/backpack.mjs";
import { BeltTemplate } from "./upload/belt.mjs";
import { UmbrellaTemplate } from "./upload/umbrella.mjs";


export default function Upload({ loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;

    const apparelGenre = ['Hoodie', 'T-shirt', 'Shirt', 'Kurti',
        'Saree', 'Jacket', 'Kurta', 'Shawl', 'Tracksuit',
        'Leggings', 'Dress', 'Skirt', 'Jeans', 'Lehenga', 'Top', 'Co ord set', 'Hand bag', 'Hand purse',
        'Wallet', 'Backpack', 'Belt', 'Umbrella'
    ];

    const accessoriesGenre = ['Ear rings', 'Band'];

    const prod = ['Apparel', 'Accessories'];

    const [prodInfo, setProdInfo] = useState({});

    const navigate = useNavigate();

    const [prodSelected, setProdSelected] = useState(null);

    let jToken = localStorage.getItem('token');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiURL}/api/upload`, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'Application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    credentials: 'include'
                })
                if (response.status === 500) {
                    throw new Error('Error while loading upload page');
                } else {
                    if (response.status !== 200) {
                        navigate('/login');
                    }
                }
            } catch (error) {
                // await loginStatus();
                navigate('/error');
                console.log(error.message);
            }
        }
        fetchData();
    }, [loginStatus, apiURL, navigate, jToken]);

    return (
        <>
            <div className={`${styles.uploadmainDiv}`}>
                <span style={{ fontSize: '20px', fontWeight: '700', letterSpacing: '1px' }}>List your product</span>
                <div className={`${styles.uploadGenreDiv}`}>
                    <label for='prod'>
                        Product Type
                    </label>
                    <select className={`${styles.sellerUploadSelect}`} id='prod' required name='prod' onChange={(e) => { setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) }); setProdSelected(e.target.value) }} form="uploadForm">
                        <option value='' selected disabled hidden></option>
                        {prod.map(item => {
                            return (
                                <>
                                    <option value={item}>{item}</option>
                                </>
                            )
                        })}
                    </select>
                </div>

                {
                    prodSelected === 'Apparel' ?
                        (
                            <>
                                <div className={`${styles.uploadGenreDiv}`}>
                                    <label for='genre'>
                                        Product genre
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='genre' required name='genre' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        {/* <option value='' selected disabled hidden></option> */}
                                        <option value='' selected >Select Any</option>

                                        {apparelGenre.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>
                            </>

                        ) :

                        (
                            <>
                                <div className={`${styles.uploadGenreDiv}`} style={!prodSelected ? { display: 'none' } : {}}>
                                    <label for='genre'>
                                        Product genre
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='genre' required name='genre' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        {/* <option value='' selected disabled>Select Any</option> */}
                                        <option value='' selected >Select Any</option>
                                        {accessoriesGenre.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}

                                    </select>
                                </div>
                            </>
                        )
                }

                {['Shirt', 'T-shirt'].includes(prodInfo.genre) ? <ShirtTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                    prodInfo.genre === 'Hoodie' ? <HoodieTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                        prodInfo.genre === 'Kurti' ? <KurtiTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                            prodInfo.genre === 'Kurta' ? <KurtaTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                prodInfo.genre === 'Saree' ? <SareeTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                    prodInfo.genre === 'Jacket' ? <JacketTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                        prodInfo.genre === 'Shawl' ? <Shawlemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                            prodInfo.genre === 'Tracksuit' ? <TracksuitTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                prodInfo.genre === 'Leggings' ? <LeggingsTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                    prodInfo.genre === 'Dress' ? <DressTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                        prodInfo.genre === 'Skirt' ? <SkirtTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                            prodInfo.genre === 'Top' ? <TopTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                                prodInfo.genre === 'Lehenga' ? <LehengaTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                                    prodInfo.genre === 'Jeans' ? <JeansTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                                        prodInfo.genre === 'Hand bag' ? <HandBagTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                                            prodInfo.genre === 'Hand purse' ? <HandPurseTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                                                prodInfo.genre === 'Wallet' ? <WalletTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                                                    prodInfo.genre === 'Belt' ? <BeltTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                                                        prodInfo.genre === 'Backpack' ? <BackpackTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                                                            prodInfo.genre === 'Co ord set' ? <CoordTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                                                                prodInfo.genre === 'Umbrella' ? <UmbrellaTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                                                                    prodInfo.genre === 'Ear rings' ? <EarringTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                                                                        prodInfo.genre === 'Band' ? <BandTemplate loginStatus={loginStatus} prodInfo={prodInfo} setProdInfo={setProdInfo} /> :
                                                                                                            <></>}
            </div>
        </>
    )
}